import { useState } from "react";
import { uploadPermitExcel, downloadPermitTemplate } from "../../api/permit";
import { Loader2, Upload, FileDown } from "lucide-react";

export default function ExcelUpload({ onUploaded }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return alert("엑셀 파일을 선택하세요.");
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const res = await uploadPermitExcel(formData);
      alert(res.data.message);
      onUploaded?.();
      setFile(null);
    } catch (err) {
      alert("업로드 실패: " + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const res = await downloadPermitTemplate();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "인허가_일괄_등록.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert("다운로드 실패: " + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="rounded-lg border bg-white p-4 shadow-sm text-sm">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <h3 className="font-semibold text-gray-800">인허가 엑셀 업로드</h3>
        <button
          onClick={handleDownload}
          className="flex items-center gap-1 rounded-md px-2.5 py-1.5 hover:bg-gray-100 text-gray-700 transition"
        >
          <FileDown size={14} />
          양식
        </button>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {/* 파일 선택 */}
        <label className="cursor-pointer flex items-center gap-2 rounded-md border border-dashed border-gray-300 bg-gray-50 px-3 py-1.5 text-gray-600 hover:border-indigo-400 hover:bg-indigo-50 transition">
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files[0])}
            className="hidden"
          />
          {file ? file.name : "파일 선택"}
        </label>

        {/* 업로드 버튼 */}
        <button
          onClick={handleUpload}
          disabled={loading}
          className="flex items-center gap-1 rounded-md px-3 py-1.5 border hover:bg-gray-400 text-xs font-medium disabled:opacity-60 transition"
        >
          {loading ? (
            <>
              <Loader2 size={14} className="animate-spin" />
              업로드 중...
            </>
          ) : (
            <>
              <Upload size={14} />
              업로드
            </>
          )}
        </button>
      </div>

      <p className="mt-2 text-xs text-red-500">
        ※ 양식을 다운로드 받고 내용을 기입한 후 해당 파일을 업로드해주세요. ※
      </p>
    </div>
  );
}
